import { Chain, getDefaultConfig } from "@rainbow-me/rainbowkit";
import { AAVEIcon, DAIIcon, EURSIcon, GASIcon, LINKIcon, NEOIcon, SWTHIcon, USDCIcon, USDTIcon, WBTCIcon, WETHIcon, WSTETHIcon } from "../../assets";
import { FunctionComponent, SVGProps } from "react";

export const DECIMALS = 18;
export const PRICE_DECIMALS = 8; //TODO: temp placeholder
export const RAY_DECIMALS = 27;
export const ORACLE_BASE_CURRENCY_UNIT_DECIMALS = 8;
export const BASE_TOKEN = 'USDC'; //TODO: Temp placeholder
export const MAX_SPENDING_LIMIT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'
export const SECONDS_PER_YEAR = 31536000

interface TokenMapping {
  [key: string]: {
    name: string;
    iconUrl: FunctionComponent<SVGProps<SVGSVGElement>>;
    // decimals: number;
    // contractAddress: `0x${string}`;
  };
}

//use Uppercase for the key
export const tokenMapping: TokenMapping = {
  'USDC': {
    name: 'USD Coin',
    iconUrl: USDCIcon,
  },
  'DAI': {
    name: 'DAI Coin',
    iconUrl: DAIIcon,
  },
  'LINK': {
    name: 'LINK Coin',
    iconUrl: LINKIcon,
  },
  'WBTC': {
    name: 'Wrapped Bitcoin',
    iconUrl: WBTCIcon,
  },
  'WETH': {
    name: 'Wrapped Ethereum',
    iconUrl: WETHIcon,
  },
  'WSTETH': {
    name: 'Wrapped Staked Ethereum',
    iconUrl: WSTETHIcon,
  },
  'USDT': {
    name: 'USD Tether',
    iconUrl: USDTIcon,
  },
  'AAVE': {
    name: 'AAVE Coin',
    iconUrl: AAVEIcon,
  },
  'EURS': {
    name: 'EUR Coin',
    iconUrl: EURSIcon,
  },
  'SWTH': {
    name: 'Switcheo Token',
    iconUrl: SWTHIcon,
  },
  'NEO': {
    name: 'Neo',
    iconUrl: NEOIcon,
  },
  'WGAS': {
    name: 'Wrapped GAS',
    iconUrl: GASIcon,
  },
  'WGAS10': {
    name: 'Wrapped GAS',
    iconUrl: GASIcon,
  },
}

export const siteMap = {
  markets: { path: "/", name: "Markets", display: true },
  portfolio: { path: "/portfolio", name: "Portfolio", display: true },
  tokenDetails: { path: "/token/:denom", name: "Token Details", display: false },
  wallet: { path: "/wallet", name: "Wallet", display: false },
  rewards: { path: "/rewards", name: "Rewards", display: false },
}

export const socialLinks = {
  discord: "https://discord.gg/",
  twitter: "https://x.com/Intersect_fi",
  github: "",
  telegram: "https://t.me/intersectfinanceannouncement",
  docs: "https://docs.intersectfi.com"
}

export const apiLinks = {
  testnet: "https://test-api.intersectfi.com",
  mainnet: "https://api.intersectfi.com"
}

export const NeoXChain = {
  id: 12_227_332,
  name: 'NeoX',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1376.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'GAS', symbol: 'GAS', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://testnet.rpc.banelabs.org/'] },
  },
  blockExplorers: {
    default: { name: 'Xt4', url: 'https://xt4scan.ngd.network/' },
  },
  contracts: {
    multicall3: {
      address: '0x82096F92248dF7afDdef72E545F06e5be0cf0F99',
      // blockCreated: 11_907_934,
    },
  },
} as const satisfies Chain;

export const config = getDefaultConfig({
  appName: 'Intersect',
  projectId: 'NEOX_INTERSECT',
  chains: [NeoXChain],
  ssr: false, // If your dApp uses server side rendering (SSR)
});